/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_VersionInputs */

const en_gc_resources_download_version = /** @type {(inputs: Gc_Resources_Download_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft v0.7.0 · Alpha release`)
};

const zh_gc_resources_download_version = /** @type {(inputs: Gc_Resources_Download_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft v0.7.0 · Alpha 版本`)
};

/**
* | output |
* | --- |
* | "GridCraft v0.7.0 · Alpha release" |
*
* @param {Gc_Resources_Download_VersionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_version = /** @type {((inputs?: Gc_Resources_Download_VersionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_VersionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_version(inputs)
	return zh_gc_resources_download_version(inputs)
});
export { gc_resources_download_version as "gc.resources.download.version" }